"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scriptCategoryClassName = exports.hasUserRejectedAllCategories = exports.isActiveCategoryId = exports.getActiveCategoryIds = exports.isCookieConsentGiven = exports.isOneTrustInitialised = exports.isBrowser = void 0;
const constants_1 = require("../constants");
const isBrowser = () => typeof window !== 'undefined';
exports.isBrowser = isBrowser;
const isOneTrustInitialised = () => Boolean(window.OneTrust);
exports.isOneTrustInitialised = isOneTrustInitialised;
/**
 * Checks whether user has given consent for cookies
 * based on OneTrust cookie banner status.
 */
const isCookieConsentGiven = () => {
    if ((0, exports.isOneTrustInitialised)()) {
        return window.OneTrust.IsAlertBoxClosed();
    }
    return Boolean(document.cookie.match(constants_1.OneTrustCookieNames.OptanonAlertBoxClosed));
};
exports.isCookieConsentGiven = isCookieConsentGiven;
const getActiveCategoryIds = () => window.OnetrustActiveGroups.split(',').filter(Boolean);
exports.getActiveCategoryIds = getActiveCategoryIds;
const isActiveCategoryId = (category) => (0, exports.getActiveCategoryIds)().includes(category);
exports.isActiveCategoryId = isActiveCategoryId;
const hasUserRejectedAllCategories = () => (0, exports.getActiveCategoryIds)().length <= constants_1.DEFAULT_ENABLED_CATEGORIES.length;
exports.hasUserRejectedAllCategories = hasUserRejectedAllCategories;
/**
 * The number in the class identifier corresponds to the cookie category id
 * for the cookies that the script loads.
 *
 * Initially type attribute for the script should be "text/plain".
 *
 * Then, when the Cookie Consent code loads, if cookies for the associated category have consent,
 * it will dynamically change the tag to: script type="text/javascript" – the code
 * inside the tags will then be recognized and run as normal.
 *
 * When you list multiple categories using this method, the categories are blocked concurrently.
 * None of the cookies in these categories will be set unless the site visitor consents to all
 * of the categories being blocked.
 *
 * @example
 * <script type="text/plain" class="optanon-category-C0002-C0003">
 *   code
 * </script>
 **/
const scriptCategoryClassName = (...categoryIds) => `optanon-category-${categoryIds.join('-')}`;
exports.scriptCategoryClassName = scriptCategoryClassName;
//# sourceMappingURL=index.js.map